import Vue from 'vue';
import Vuetify, {
  VSelect,
  VTextField,
  VDatePicker,
  VCalendar,
  VCheckbox,
  VFlex,
  VAutocomplete,
  VSwitch,
  VTextarea,
  VRow,
  VTooltip,
  VBtn,
} from 'vuetify/lib';
import Touch from 'vuetify/es5/directives/touch';
import Resize from 'vuetify/es5/directives/resize';

Vue.use(Vuetify, {
  components: {
    VSelect,
    VTextField,
    VDatePicker,
    VCalendar,
    VCheckbox,
    VFlex,
    VAutocomplete,
    VSwitch,
    VTextarea,
    VRow,
    VTooltip,
    VBtn,
  },
  directives: {
    Touch,
    Resize,
  },
});

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {},
    },
  },
});
